import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable()
export class FixActionService {

  constructor(
    private _http: HttpClient
  ) { }
  updateActionForm(updatedObj: any){
     return this._http.post(environment.serverUrl + '/task/hazard/', updatedObj);
  }
  previewActionForm(updatedObj){
    return this._http.post(environment.serverUrl + '/task/preview/', updatedObj);
  }
}



// WEBPACK FOOTER //
// ./src/app/fix-action-form/fix-action.service.ts